import React from 'react';
import loadable from '@loadable/component';
import parse from 'html-react-parser';

const isServer = typeof window === 'undefined';

export default function IconComponent(props) {
  const { icon = 'icon', id, ...other } = props;
  const renderIcon = () => {
    return loadable(() => import('../icon'));
  };
  if (isServer) {
    const Icon = renderIcon();
    return (
      <Icon
        {...other}
        id={props.id || `icon-${props.icon || 'icon'}`}
        icon={icon}
      />
    );
  }
  const child = props.id
    ? document.getElementById(`${props.id}`)
    : document.getElementById(`icon-${props.icon || 'icon'}`);
  const IconFallback = !child && renderIcon();
  return (
    <>
      {child ? (
        parse(child.outerHTML)
      ) : (
        <IconFallback
          {...other}
          icon={icon}
          id={props.id || `icon-${props.icon}`}
        />
      )}
    </>
  );
}
